import { useInterval } from '@equifinance/shared';
import axios from 'axios';
import { useRef, useEffect } from 'react';

const APP_VERSION_INTERVAL = 10 * 60 * 1000;

const fetchAppVersion = async (): Promise<string> => {
  try {
    const response = await axios.get('/portal/version');
    return response?.data?.toString() || '';
  } catch (e) {
    return '';
  }
};

export default function useAppVersionDetector(onNewVersionDetected: () => void, interval: number = APP_VERSION_INTERVAL) {
  const currentAppVerRef = useRef('');

  useEffect(() => {
    (async () => {
      const appVersion = await fetchAppVersion();
      currentAppVerRef.current = appVersion;
    })();
  }, []);

  async function detectNewAppVersion() {
    const appVersion = await fetchAppVersion();

    if (!!appVersion && currentAppVerRef.current !== appVersion) {
      onNewVersionDetected();
    }
  }

  useInterval(() => {
    detectNewAppVersion();
  }, interval);
}
